export function getNTPTaboolaWidgetForPlacement(
  placement: string
): Partial<TaboolaProps> | undefined {
  const container = `taboola-homepage-${placement}`
  const mode = 'thumbnails-r-267x178-v2'

  return {
    containerName: container,
    mode: mode,
  }
}

export const taboolaMixins: Record<string, Partial<TaboolaProps>> = {}
